import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/sidebar.css";

export function Sidebar({ collapsed, setCollapsed }) {
    const { t } = useTranslation();
    
	return (
		<div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
			<button onClick={() => setCollapsed(!collapsed)} className="toggle-btn">
				☰
			</button>
			<nav>
				<NavLink
					to="/passgenerator"
					end
					className={({ isActive }) =>
						isActive ? "menu-item active" : "menu-item"
					}
				>
					Pass Generator
				</NavLink>
			</nav>
		</div>
	);
}
